<script lang="ts" setup>
import { computed, ref, watch } from 'vue';
import VSpinnerV2 from '@shared/component/VSpinnerV2/VSpinnerV2.vue';
import { menu, MenuItem } from '../../store/menu';
import NavigationList from './NavigationList.vue';

const props = defineProps<{
  navigateInFrame: boolean;
  menuItems?: Array<MenuItem>;
  isLoading: boolean;
}>();

const emit = defineEmits<{ reload: [] }>();

const menuIsOpen = computed(() => menu.show);
const scrollY = ref(0);
const menuTop = ref(115);

watch(
  () => menuIsOpen.value,
  value => {
    const header = document.getElementById('app-header');
    const headerHeight = header?.getBoundingClientRect().height || 115;
    const headerTop = header?.getBoundingClientRect().top || 0;
    menuTop.value = headerTop + headerHeight;
    scrollLock(value);
  }
);

function toggleMenu() {
  menu.toggle();
}

function scrollLock(lock: boolean) {
  if (lock) {
    scrollY.value = window.scrollY;
    document.body.classList.add('scroll-lock');
    document.body.style.top = `-${scrollY.value}px`;
  } else {
    document.body.classList.remove('scroll-lock');
    window.scrollTo(0, scrollY.value);
    scrollY.value = 0;
  }
}
</script>

<template>
  <div class="overlay tw-fixed" :class="{ 'is-open': menuIsOpen }" @click="toggleMenu"></div>
  <div
    class="nav-panel tw-fixed tw-z-header"
    :class="{ '-tw-translate-x-full': !menuIsOpen }"
    :style="{ top: 'var(--header-height, 0)', height: `calc(100vh - var(--header-height, 0px))` }">
    <div v-if="isLoading" class="nav-wrapper center sm:tw-w-64 sm:tw-min-w-64">
      <VSpinnerV2 variant="white" />
    </div>
    <div class="nav-wrapper sm:tw-w-64 sm:tw-min-w-64" v-else>
      <NavigationList
        v-if="props.menuItems"
        @reload="emit('reload')"
        :navigate-in-frame="props.navigateInFrame"
        :menu-items="props.menuItems" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.overlay {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 200;
  display: none;
  transition: all 0.2s;
  &.is-open {
    display: flex;
  }
}
.nav-panel {
  top: 115px;
  background: var(--primary-dark);
  height: calc(100vh - var(--header-height));
  transition: transform 0.2s;
  overflow-x: hidden;
  overflow-y: auto;
}

.nav-wrapper {
  border-right: 1px solid #d3d3d32e;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding-top: 1em;
  width: 100vw;
  min-width: 100vw;

  &.center {
    height: calc(100% - 2em);
    justify-content: center;
  }
}
.no-border {
  border: none;
}

.nav-panel::-webkit-scrollbar-track {
  border-radius: 0px;
  background-color: #dbdbdb;
}

.nav-panel::-webkit-scrollbar {
  width: 12px;
  background-color: #dbdbdb;
}

.nav-panel::-webkit-scrollbar-thumb {
  border-radius: 0px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  background-color: var(--primary-dark);
}
</style>
